import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';
import { lg, md, xl, xl2 } from '../common';

export function initPostTreatment() {
  const parent = document.querySelector('.post-treatment');
  if (!parent) return;

  const swiper = parent.querySelector('.js-post-treatment__swiper');
  const prevEl = parent.querySelector('.swiper-button-prev');
  const nextEl = parent.querySelector('.swiper-button-next');

  new Swiper(swiper, {
    modules: [Pagination, Navigation],
    slidesPerView: 1,
    spaceBetween: 12,
    navigation: {
      nextEl,
      prevEl,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      [md]: {
        slidesPerView: 2,
        spaceBetween: 12,
      },
      [lg]: {
        enabled: false,
        slidesPerView: 'auto',
        spaceBetween: 0,
      },
    },
  });
}
